import { request, util } from '@tencent/ppd-base-libs';

// 所有类型的 tnc 配置
const allTncTypeConfig: {[key: string]: { content: string; title: string; type: string; tncId: string }[]} = {};
/**
 * 获取对应 tnc 链接的tnc 内容
 * @param tncUrl tnc 链接
 * @returns
 */
export async function getTncConfigContent(tncUrl: string): Promise<string> {
  const patternType = /[?|&]type=([^&#]+)/;
  const patternTncId = /[?|&]tncId=([^&#]+)/;
  const [type, tncId] = [tncUrl.match(patternType)?.[1], tncUrl.match(patternTncId)?.[1]];

  if (!type || !tncId) return '';

  if (!allTncTypeConfig[type]) {
    const url = `https://st.moneydata.hk/wuji/config/tncCfg/${type}.json`;
    const [err, result] = await util.to(request.loadVtools(url));
    if (err || !result) return '';
    allTncTypeConfig[type] = result;
  }

  const tncConfig = allTncTypeConfig[type].find(ele => ele.tncId === tncId);
  return tncConfig?.content || '';
};
